import { render, staticRenderFns } from "./dishCardContainer.vue?vue&type=template&id=4b56c9f4&scoped=true&class=my-dishes"
import script from "./dishCardContainer.vue?vue&type=script&lang=js"
export * from "./dishCardContainer.vue?vue&type=script&lang=js"
import style0 from "./dishCardContainer.vue?vue&type=style&index=0&id=4b56c9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b56c9f4",
  null
  
)

export default component.exports